import React from 'react'
import { Card } from '../../../../../../components/Card'
import Table from '../../../../../../components/Table'
import Icon from '../../../../../../components/Icon'
import InfoBar from '../../../../../../modules/InfoBar'
import Value from '../../../../../../components/Value'
import { pathOr } from 'ramda'

const Overlap = ({ infoBar, overlap }) => {
    return (
        <>
            {
                infoBar &&
                <InfoBar
                    lastUpdate={infoBar.lastUpdate}
                    translation={infoBar.translation}
                    noContainer
                />
            }
            <Card
                style={{
                    maxWidth: pathOr('unset', ['style', 'maxWidth'], overlap),
                    margin: '0 auto'
                }}
            >
                {
                    overlap &&
                    <Table
                        columns={[
                            ...overlap.header.map(({style, ...rest}) => ({
                                ...rest,
                                cell: item => <Value item={item} />
                            })),
                            {
                                cell: () => <Icon name='arrow' />,
                                style: {
                                    maxWidth: '14px',
                                    alignSelf: 'center',
                                    marginRight: 0
                                }
                            }
                        ]}
                        data={overlap.items}
                        divider
                        minWidth={pathOr('unset', ['style', 'minWidth'], overlap)}
                        hover
                        to={item => ({
                            pathname: `/manage/herd/cow/${item.row_no}`,
                            state: {
                                rowid: item.row_id
                            }
                        })}
                    />
                }
            </Card>
        </>
    )
}

export default Overlap
